import type { SVGProps } from 'react';
import { Box } from '@mui/material';
import { TECH_GLYPHS } from './techGlyphs';

/**
 * Glifi SVG di elevazione porta portati 1:1 dai componenti legacy (hc frontend legacy,
 * components/Icons/*). Il render di card/base non è un raster R2 (il layer di planimetria è un glifo
 * top-view, inadatto): è questo disegno di elevazione, scelto per TIPO/stato. Il nome del glifo arriva
 * dal backend (`AvailableOption.glyph`), così il FE resta thin. `currentColor` = colore del tratto
 * (impostato dal contenitore); i riempimenti neutri sono ripresi tali e quali dal legacy.
 */

function SwingDoor(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 72 117" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M23.059 117s.152-77.695 0-116.238V0l47.944 7.77V108.62l-.611.152C52.68 111.516 23.059 117 23.059 117zM24.433 1.676s0 30.926.152 56.824v56.672s12.215-2.59 45.196-7.77V8.836l-45.348-7.16z"
        fill="currentColor"
      />
      <path
        d="M30.848 54.082c-.916 0-1.832 1.676-1.832 3.961s.916 3.96 1.832 3.96 1.832-1.675 1.832-3.96-.916-3.961-1.832-3.961zM17.254 108.316v1.676H0V6.398h17.254v1.676H1.68V108.47h15.574v-.153z"
        fill="currentColor"
      />
    </svg>
  );
}

function PortaScorrevole(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 45 77" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#porta-scorrevole_svg__clip0)">
        <path d="M42.94 2.4H24.48v71.18h18.46V2.4z" fill="#EFEEEE" />
        <path
          d="M0 0v76.73h44.86V0H0zm1.91 74.82V1.9h41v.54H23.8v71.89h.78V3.22h18.37v71.6H1.91z"
          fill="currentColor"
        />
        <path
          d="M28.09 36.16a1.8 1.8 0 00-1.265 3.066c.336.336.791.524 1.266.524a1.8 1.8 0 001.8-1.79 1.81 1.81 0 00-1.8-1.8zm0 2.82a1 1 0 110-2 1 1 0 010 2z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="porta-scorrevole_svg__clip0">
          <path fill="#fff" d="M0 0h44.85v76.73H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

function PortaTelaioVisibile(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 46 77" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#porta-telaio-visibile_svg__clip0)">
        <path
          d="M43.18 2.18h-41v72.38h41V2.18zM5.29 39.69a1.74 1.74 0 01-1.74-1.73 1.74 1.74 0 011.74-1.74 1.74 1.74 0 011.73 1.74 1.74 1.74 0 01-1.73 1.73z"
          fill="#EFEEEE"
        />
        <path d="M0 0v76.74h45.36V0H0zm43.18 74.56h-41V2.18h41v72.38z" fill="currentColor" />
        <path
          d="M5.29 36.22a1.739 1.739 0 00-1.74 1.74 1.74 1.74 0 001.74 1.73 1.74 1.74 0 001.73-1.73 1.74 1.74 0 00-1.73-1.74zm0 3a1.23 1.23 0 01-1.24-1.23 1.23 1.23 0 011.24-1.24 1.229 1.229 0 011.23 1.24 1.23 1.23 0 01-1.23 1.2v.03z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="porta-telaio-visibile_svg__clip0">
          <path fill="#fff" d="M0 0h45.35v76.73H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

function PortaRasomuro(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 253 214" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M188.324.879h-123v212.3h123V.879z" fill="#e8e8e8" />
      <path
        d="M188.624 213.439H65.074V.629h123.55v212.81zm-123-.5h122.5V1.129h-122.5v211.81z"
        fill="currentColor"
      />
      <path
        d="M77.325 110.509a4.702 4.702 0 01-3.32-8.027 4.704 4.704 0 017.233.723c.515.775.789 1.684.787 2.614a4.686 4.686 0 01-2.902 4.336 4.679 4.679 0 01-1.798.354zM65.205.51H.625v.5h64.58v-.5zM65.205 213.189H.625v.5h64.58v-.5zM252.904.51h-64.58v.5h64.58v-.5zM252.904 213.189h-64.58v.5h64.58v-.5z"
        fill="currentColor"
      />
    </svg>
  );
}

function PortaAltezzaStandard(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 123 159" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M.113 158.1h93.2V0H.113v158.1zM.883.77h91.66v156.56H.883V.77z" fill="currentColor" />
      <path
        d="M3.965 154.25h85.5V3.85h-85.5v150.4zm.77-149.62h84v148.84h-84V4.63zM122.343 2.98V.85h-9.57v2.13h4.21v153.07h-4.21v2.12h9.57v-2.12h-4.2V2.98h4.2z"
        fill="currentColor"
      />
      <path d="M80.103 79.98h-16.9v2.9h16.9v-2.9z" fill="currentColor" />
    </svg>
  );
}

function PortaAltezza(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 253 247" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M188.043 34.17h-123v212.3h123V34.17z" fill="#e8e8e8" />
      <path
        d="M188.343 246.72H64.793V33.92h123.55v212.8zm-123-.5h122.5V34.42h-122.5v211.8z"
        fill="currentColor"
      />
      <path
        d="M77.044 143.839a4.695 4.695 0 01-4.343-2.901 4.699 4.699 0 016.141-6.141 4.701 4.701 0 010 8.685 4.703 4.703 0 01-1.798.357zM64.924 33.79H.344v.5h64.58v-.5zM64.924 246.471H.344v.5h64.58v-.5zM252.623 33.79h-64.58v.5h64.58v-.5zM252.623 246.471h-64.58v.5h64.58v-.5z"
        fill="currentColor"
      />
      <path d="M216.965 34.17h-2v211.26h2V34.17z" fill="#991914" />
      <path
        d="M220.465 244.43h-9v2h9v-2zM220.465 33.17h-9v2h9v-2zM216.652 32.51h-1V31h1v1.51zm0-3.5h-1v-3h1v3zm0-5.08h-1v-3h1v3zm0-5.08h-1v-3h1v3zm0-5.08h-1v-3.1h1v3.1zm0-5.09h-1v-3h1v3zm0-5.08h-1V.51h1V3.6z"
        fill="#991914"
      />
    </svg>
  );
}

function PortaGrezza(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 253 214" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M187.699 0.369141H64.6992V212.669H187.699V0.369141Z" fill="#EFEAEA" />
      <path
        d="M187.999 212.929H64.4492V0.119141H187.999V212.929ZM64.9992 212.429H187.499V0.619141H64.9992V212.429Z"
        fill="currentColor"
      />
      <path
        d="M76.7 110C75.77 110 74.8609 109.724 74.0878 109.207C73.3146 108.69 72.7122 107.955 72.3568 107.096C72.0014 106.237 71.9089 105.291 72.091 104.379C72.2732 103.467 72.7218 102.63 73.3801 101.973C74.0384 101.316 74.8768 100.869 75.7892 100.689C76.7016 100.508 77.6469 100.603 78.5055 100.96C79.3642 101.318 80.0975 101.921 80.6128 102.696C81.128 103.47 81.402 104.38 81.4 105.31C81.4 105.926 81.2783 106.537 81.042 107.107C80.8057 107.676 80.4594 108.194 80.0228 108.629C79.5862 109.065 79.068 109.41 78.4978 109.645C77.9277 109.881 77.3167 110.001 76.7 110V110Z"
        fill="currentColor"
      />
      <path d="M64.58 0H0V0.5H64.58V0Z" fill="currentColor" />
      <path d="M64.58 212.68H0V213.18H64.58V212.68Z" fill="currentColor" />
      <path d="M252.279 0H187.699V0.5H252.279V0Z" fill="currentColor" />
      <path d="M252.279 212.68H187.699V213.18H252.279V212.68Z" fill="currentColor" />
      <circle cx="188.5" cy="107.5" r="37.25" fill="white" stroke="currentColor" strokeWidth="0.5" />
    </svg>
  );
}

/** Registry: nome glifo (dal BE) → componente SVG. Chiavi allineate a option-glyph.ts (BE). */
const GLYPHS: Record<string, (props: SVGProps<SVGSVGElement>) => JSX.Element> = {
  swingDoor: SwingDoor,
  portaScorrevole: PortaScorrevole,
  portaTelaioVisibile: PortaTelaioVisibile,
  portaRasomuro: PortaRasomuro,
  portaAltezzaStandard: PortaAltezzaStandard,
  portaAltezza: PortaAltezza,
  portaGrezza: PortaGrezza,
  // Glifi TECNOLOGIA (luci/prese/smart), stesso registry.
  ...TECH_GLYPHS,
};

interface DoorGlyphProps {
  /** Nome del glifo dal BE (`AvailableOption.glyph`). Se sconosciuto/null → non renderizza nulla. */
  name: string | null;
  /** Altezza in px del disegno (la larghezza segue il rapporto del viewBox). Default 72. */
  height?: number;
  /** Etichetta accessibile del render. */
  label?: string;
}

/**
 * Render del glifo di elevazione porta per nome (dal BE). Centrato, altezza fissa, larghezza
 * proporzionale al viewBox. Ritorna null se il nome non è mappato (nessun fallback strano).
 */
export function DoorGlyph({ name, height = 72, label }: DoorGlyphProps): JSX.Element | null {
  const Glyph = name ? GLYPHS[name] : undefined;
  if (!Glyph) return null;
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height,
        color: 'text.primary',
      }}
    >
      <Glyph
        height="100%"
        width="auto"
        role="img"
        aria-label={label}
        focusable={false}
        style={{ maxWidth: '100%' }}
      />
    </Box>
  );
}
